/* Domma · animaciones ligeras: aparición al hacer scroll (.dm-rv), contadores ([data-dm-count]), test de síntomas ([data-dm-quiz]). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function count(el) {
    var to = parseFloat(el.getAttribute('data-dm-count')) || 0, dec = (el.getAttribute('data-dm-count').split('.')[1] || '').length;
    var pre = el.getAttribute('data-dm-pre') || '', suf = el.getAttribute('data-dm-suf') || '';
    if (reduce) { el.textContent = pre + to.toLocaleString('es-MX', { minimumFractionDigits: dec }) + suf; return; }
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (to * e).toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    var els = root.querySelectorAll('.dm-rv:not(.is-in), [data-dm-count]:not([data-dm-done])');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); if (e.hasAttribute('data-dm-count')) count(e); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var e = en.target; io.unobserve(e);
        e.classList.add('is-in');
        if (e.hasAttribute('data-dm-count')) { e.setAttribute('data-dm-done', ''); count(e); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });

    root.querySelectorAll('[data-dm-quiz]:not([data-ready])').forEach(function (q) {
      q.setAttribute('data-ready', '');
      var chips = q.querySelectorAll('.dm-quiz__chip'), bar = q.querySelector('[data-dm-quiz-bar]'),
          msg = q.querySelector('[data-dm-quiz-msg]'), cta = q.querySelector('[data-dm-quiz-cta]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          var n = q.querySelectorAll('.dm-quiz__chip[aria-pressed="true"]').length;
          bar.style.width = Math.round(n / chips.length * 100) + '%';
          msg.textContent = n === 0 ? msg.dataset.m0 : (n < 3 ? msg.dataset.m1 : msg.dataset.m2);
          cta.hidden = n === 0;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* carrusel de tarjetas: flechas */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-dm-prev],[data-dm-next]'); if (!b) return;
  var t = b.closest('[data-dm-car]').querySelector('.dm-car__track'), c = t.querySelector('.dm-card');
  var step = c ? c.getBoundingClientRect().width + 14 : 300;
  t.scrollBy({ left: b.hasAttribute('data-dm-next') ? step : -step, behavior: 'smooth' });
});

/* barra de compra fija: visible cuando el bloque de compra queda fuera de pantalla */
(function () {
  function setup() {
    var bar = document.querySelector('[data-dm-sticky]'), anchor = document.getElementById('dm-buy');
    if (!bar || !anchor || bar.dataset.ready) return; bar.dataset.ready = '1'; bar.hidden = false;
    var tick = false;
    function check() {
      tick = false;
      var btn = [].slice.call(document.querySelectorAll('.product-information button[name="add"], .product-information .add-to-cart-button')).filter(function (x) { return x.offsetHeight > 0; })[0];
      var past = btn ? btn.getBoundingClientRect().bottom < 0 : window.scrollY > 900;
      var foot = document.querySelector('.dm-foot'); var nearEnd = foot && foot.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-on', past && !nearEnd);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
})();

/* vídeos: sin autoplay al hacer scroll (ver «vídeos v2» más abajo: solo se reproducen al tocarlos) */

/* paralaje suave del fondo de las cifras */
(function () {
  var bgs = [], tick = false;
  function run() { tick = false; bgs.forEach(function (b) { var r = b.parentNode.getBoundingClientRect(); var k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; b.style.transform = 'translateY(' + (k * -40).toFixed(1) + 'px)'; }); }
  function setup() { bgs = [].slice.call(document.querySelectorAll('.dm-statsec__bg')); if (!bgs.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return; addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true }); run(); }
  document.addEventListener('DOMContentLoaded', setup);
})();

/* «tu proceso»: la línea se rellena de rojo y las etapas pasadas se encienden al hacer scroll */
(function () {
  var lists = [], tick = false;
  function run() {
    tick = false;
    lists.forEach(function (l) {
      var r = l.getBoundingClientRect(), mid = innerHeight * 0.55;
      var p = Math.max(0, Math.min(1, (mid - r.top) / r.height));
      l.style.setProperty('--dm-fill', (p * 100).toFixed(1) + '%');
      l.querySelectorAll(':scope > li').forEach(function (li) { li.classList.toggle('is-pass', li.getBoundingClientRect().top < mid); });
    });
  }
  function setup() { lists = [].slice.call(document.querySelectorAll('.dm-jr__list')); if (!lists.length) return; addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true }); run(); }
  document.addEventListener('DOMContentLoaded', setup);
})();

/* carruseles: puntos de progreso sincronizados con el scroll */
(function () {
  function setup() {
    document.querySelectorAll('[data-dm-car]:not([data-dots])').forEach(function (car) {
      car.setAttribute('data-dots', '');
      var tr = car.querySelector('.dm-car__track'), items = tr.children; if (items.length < 2) return;
      var d = document.createElement('div'); d.className = 'dm-car__dots';
      for (var i = 0; i < items.length; i++) d.appendChild(document.createElement('i'));
      tr.parentNode.insertBefore(d, tr.nextSibling);
      function upd() {
        var w = items[0].getBoundingClientRect().width + 12, k = Math.round(tr.scrollLeft / w);
        [].forEach.call(d.children, function (x, j) { x.classList.toggle('is-on', j === Math.min(k, items.length - 1)); });
      }
      tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
    });
  }
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
})();

/* vídeos v2: sin autoplay; tocar = reproducir con sonido (uno a la vez); póster con ▶ */
(function () {
  function prep() {
    document.querySelectorAll('.dm-vid video').forEach(function (v) {
      if (v.dataset.v2) return; v.dataset.v2 = 1; v.removeAttribute('data-ok'); v.preload = 'metadata'; v.muted = false; v.loop = false;
      try { v.currentTime = 0.1; } catch (e) {}
      v.addEventListener('ended', function () { v.closest('.dm-vid').classList.remove('is-play'); });
    });
  }
  document.addEventListener('click', function (e) {
    var f = e.target.closest('.dm-vid'); if (!f) return;
    e.stopImmediatePropagation();
    var v = f.querySelector('video'); if (!v) return;
    var playing = !v.paused;
    document.querySelectorAll('.dm-vid video').forEach(function (o) { o.pause(); o.closest('.dm-vid').classList.remove('is-play'); });
    if (!playing) { v.muted = false; v.play().catch(function () {}); f.classList.add('is-play'); }
  }, true);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(prep, 0); });
})();

/* reseñas: «Ver más reseñas» */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-dm-rev-more]'); if (!b) return;
  var l = b.closest('.dm-revsec').querySelector('[data-dm-rev]'); l.classList.add('is-open'); b.parentNode.remove();
});

/* carruseles: en escritorio, si todas las tarjetas caben, ocultar flechas y puntos */
(function () {
  function fit() { document.querySelectorAll('[data-dm-car]').forEach(function (c) { var t = c.querySelector('.dm-car__track'); if (t) c.classList.toggle('is-fit', t.scrollWidth <= t.clientWidth + 4); }); }
  document.addEventListener('DOMContentLoaded', fit); addEventListener('resize', fit); addEventListener('load', fit);
})();
